import  React from 'react';
import styles from "../FilterResults.module.css";

export const Error = ({ msg }) => {
    return (<div className={styles.errorWrapper}>
        <h4>{msg === typeof 'string' ? msg : 'No results found. Try changing your filter selection.'}</h4>
    </div>);
}

